import './index.css'

const AffiliateListComponent = ({ value=[], config={}, events={} }) => {
    const handleEdit = (item) => {
        if (events.handleEdit)
            events.handleEdit(item)
    }

    const handleDelete = (item) => {
        if (events.handleDelete)
            events.handleDelete(item)
    }

    return (
        <div className="c-AffiliateList">
            <div className="affiliateList-rows">
                {value.map((item) => (
                    <div className="affiliateList-row" key={`affiliateList-row-${item.id}`}>
                        <div className="affiliateList-identity" onClick={() => handleEdit(item)}>
                            <div className="affiliateList-name">{item.displayName || item.name}</div>
                            {item.displayName && item.displayName !== item.name ? (
                                <div className="affiliateList-subName">{item.name}</div>
                            ) : null}
                        </div>

                        <div className="affiliateList-fields">
                            <div className="list-field">
                                <span className="list-fieldLabel">Referral Code</span>
                                <span className="list-fieldValue">{item.referralCode || '—'}</span>
                            </div>

                            <div className="list-field affiliateList-fieldUrl">
                                <span className="list-fieldLabel">URL</span>
                                {item.url ? (
                                    <a className="list-fieldValue" href={item.url} target="_blank" rel="noreferrer" title={item.url}>{item.url}</a>
                                ) : (
                                    <span className="list-fieldValue">—</span>
                                )}
                            </div>
                        </div>

                        <div className="affiliateList-actions">
                            <button type="button" className="affiliateList-actionButton" onClick={() => handleEdit(item)}>
                                Edit
                            </button>

                            <button type="button" className="affiliateList-actionButton affiliateList-actionButton-danger" onClick={() => handleDelete(item)}>
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export { AffiliateListComponent }
